import React from 'react';
import { useIntl } from 'react-intl';
import './styles.scss';

const RSDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <h2 className="title">
        {intl.formatMessage({
          id: 'rs.residentialService',
          defaultMessage: 'Residential Service',
        })}
      </h2>
      <h3>
        {intl.formatMessage({
          id: 'rs.rateOverview',
          defaultMessage: 'Rate Overview',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rs.residentialBody',
          defaultMessage: `The Residential Service (RS) rate schedule is designed for residential customers receiving electric delivery service from Public Service Electric and Gas Company (PSE&G). Customers can choose to purchase their electric supply from a Third Party Supplier (TPS) or from PSE&G's Basic Generation Service (BGS). The rate includes a monthly service charge and varying distribution charges based on usage and season.`,
        })}
      </p>
      <h3>
        {intl.formatMessage({
          id: 'rs.howItWorks',
          defaultMessage: 'How it Works',
        })}
      </h3>
      <ul>
        <li>
          <strong>
            {intl.formatMessage({
              id: 'rs.serviceCharge',
              defaultMessage: 'Service Charge:',
            })}
          </strong>
          <p>
            {intl.formatMessage({
              id: 'rs.tax',
              defaultMessage: `A fixed monthly fee of $5.63 (or $6.00 with New Jersey Sales and Use Tax)`,
            })}
          </p>
        </li>
        <li>
          <strong>
            {intl.formatMessage({
              id: 'rs.distribution',
              defaultMessage: 'Distribution Charges:',
            })}
            *
          </strong>
          <ul>
            <li>
              <p>
                <strong>
                  {intl.formatMessage({
                    id: 'rs.timeOne',
                    defaultMessage: 'October through May:',
                  })}
                </strong>{' '}
                {intl.formatMessage({
                  id: 'rs.rangeOne',
                  defaultMessage: `$0.045007 per kWh (up to 600 kWh), $0.045007 per kWh (over 600 kWh).`,
                })}
              </p>
            </li>
            <li>
              <p>
                <strong>
                  {intl.formatMessage({
                    id: 'rs.timeTwo',
                    defaultMessage: `June through September:`,
                  })}
                </strong>{' '}
                {intl.formatMessage({
                  id: 'rs.rangeTwo',
                  defaultMessage: `$0.077470 per kWh (up to 600 kWh), $0.081291 per kWh (over 600 kWh).`,
                })}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            {intl.formatMessage({
              id: 'rs.supplyCharges.bgs',
              defaultMessage: 'BGS Supply Charges',
            })}
          </strong>
          <ul>
            <li>
              <p>
                <strong>
                  {intl.formatMessage({
                    id: 'rs.supply.timeOne',
                    defaultMessage: 'October through May:',
                  })}
                </strong>{' '}
                {intl.formatMessage({
                  id: 'rs.supply.rangeOne.bgs',
                  defaultMessage: `$0.134599 per kWh (up to 600 kWh), $ 0.134599 per kWh (over 600 kWh)`,
                })}
              </p>
            </li>
            <li>
              <p>
                <strong>
                  {intl.formatMessage({
                    id: 'rs.supply.timeTwo',
                    defaultMessage: `June through September:`,
                  })}
                </strong>{' '}
                {intl.formatMessage({
                  id: 'rs.supply.rangeTwo.bgs',
                  defaultMessage: `$0.131800 per kWh (up to 600 kWh), $0. 141148 per kWh (over 600 kWh)`,
                })}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            {intl.formatMessage({
              id: 'rs.transmissionCharges.bgs',
              defaultMessage: 'BGS Transmission Charges',
            })}
          </strong>
          <ul>
            <li>
              <p>
                <strong>
                  {intl.formatMessage({
                    id: 'rs.transmission.timeOne',
                    defaultMessage: 'January through December:',
                  })}
                </strong>{' '}
                {intl.formatMessage({
                  id: 'rs.transmission.timeOne.value.bgs',
                  defaultMessage: `$0.063992 per kWh`,
                })}
              </p>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            {intl.formatMessage({
              id: 'rs.additional',
              defaultMessage: 'Additional Charges:',
            })}
          </strong>
          <p>
            {intl.formatMessage({
              id: 'rs.include',
              defaultMessage:
                'Include societal benefits, non-utility generation, solar pilot recovery, green programs, tax adjustments, zero emission certificates, and conservation incentives, all combined in the billing.',
            })}
          </p>
        </li>
      </ul>
      <p>
        {intl.formatMessage({
          id: 'rs.disclaimer.one',
          defaultMessage:
            '*Distribution charges include fees for infrastructure improvements and various public policy programs.',
        })}
      </p>
      <p>
        {intl.formatMessage({
          id: 'rs.disclaimer.two',
          defaultMessage:
            'Sales and usage tax are included in all of the above charges.',
        })}
      </p>
    </div>
  );
};

export default RSDetails;
